import React from 'react'
import { BaseView, BaseText } from '@/components/base'
import { useSavingsStore } from '@/store/useSavingsStore'
// removed unused currencyUtils import to match Withdraw styles

export const SetGoalAmountDisplay: React.FC = () => {
  const isFiatMode = useSavingsStore((s) => s.goal.isFiatMode)
  const fiatAmount = useSavingsStore((s) => s.goal.fiatAmount)
  const cryptoAmount = useSavingsStore((s) => s.goal.cryptoAmount)
  const triggerShake = useSavingsStore((s) => s.goal.triggerShake)

  const adaptedAmount = isFiatMode ? fiatAmount : cryptoAmount
  const displayAmount = adaptedAmount.amount || '0'

  const getFontSizeForAmount = (text: string) => {
    const length = text.length
    if (length <= 8) return 64
    if (length <= 12) return 48
    if (length <= 16) return 36
    return 24
  }

  return (
    <BaseView
      center
      style={{
        height: 74,
        justifyContent: 'center',
        alignItems: 'center',
      }}
      className={triggerShake ? 'animate-shake' : ''}
    >
      <BaseText
        fontFamily="bold"
        color="label.default"
        style={{
          fontSize: getFontSizeForAmount(displayAmount),
          lineHeight: 1,
          letterSpacing: '-0.02em',
          maxWidth: '100%',
          textAlign: 'center',
          transition: 'font-size 0.2s ease',
        }}
      >
        {displayAmount}
      </BaseText>

      <BaseText
        fontSize={16}
        fontFamily="medium"
        color="label.secondary"
        style={{
          marginTop: 4,
          textAlign: 'center',
        }}
      >
        {adaptedAmount.code}
      </BaseText>
    </BaseView>
  )
}
